var _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagForBurundiSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2 38.8c1-2 1.6-4.3 1.6-6.8c0-2.4-.6-4.7-1.6-6.8l11-11c-1.9-2.5-4.1-4.8-6.7-6.6l-11 11c-2-1-4.3-1.6-6.7-1.6s-4.7.6-6.7 1.6L14.3 7.8c-2.5 1.9-4.8 4.1-6.6 6.7l10.7 10.7c-1 2-1.6 4.3-1.6 6.8c0 2.4.6 4.7 1.6 6.8L7.6 49.5c1.8 2.6 4.1 4.8 6.6 6.7L25 45.4c2 1 4.3 1.6 6.7 1.6s4.7-.6 6.7-1.6l11 11c2.6-1.8 4.8-4.1 6.7-6.6l-10.9-11",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 17c2.4 0 4.7.6 6.7 1.6l11-11C44.6 4.1 38.5 2 32 2c-6.6 0-12.8 2.2-17.7 5.8l10.8 10.8c2-1 4.3-1.6 6.7-1.6",
    fill: "#ed4c5c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#83bf4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9 32c0 2.4-.6 4.7-1.6 6.8l11 11c3.6-5 5.8-11.1 5.8-17.7s-2.2-12.8-5.8-17.7l-11 11c1 1.9 1.6 4.2 1.6 6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 32c0-2.4.6-4.7 1.6-6.8L7.6 14.5C4.1 19.4 2 25.5 2 32s2.1 12.6 5.6 17.5l10.7-10.7c-.9-2.1-1.5-4.4-1.5-6.8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ed4c5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8 47c-2.4 0-4.7-.6-6.7-1.6L14.3 56.2c5 3.6 11.1 5.8 17.7 5.8c6.5 0 12.6-2.1 17.5-5.6l-11-11c-2 1-4.3 1.6-6.7 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8 25h-2l-1-2l-1 2h-2l1 2l-1 2h2l1 2l1-2h2l-1-2l1-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 35h-2l-1-2l-1 2h-2l1 2l-1 2h2l1 2l1-2h2l-1-2l1-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 35h-2l-1-2l-1 2h-2l1 2l-1 2h2l1 2l1-2h2l-1-2l1-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagForBurundiSvgrepoCom);
export default __webpack_public_path__ + "static/media/flag-for-burundi-svgrepo-com.6a1a0eefbc27e46a2382dd2cfd1a098f.svg";
export { ForwardRef as ReactComponent };